import { Fragment } from 'react'
import { CheckIcon, MinusIcon } from '@heroicons/react/16/solid'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'

const tiers = [
  {
    name: 'Non-member',
    comingSoon: false,
    description: 'Everything you need to get started.',
    priceMonthly: '$19',
    href: '#',
    highlights: [
      { description: 'Custom domains' },
      { description: 'Edge content delivery' },
      { description: 'Advanced analytics' },
      { description: 'Quarterly workshops', disabled: true },
      { description: 'Single sign-on (SSO)', disabled: true },
      { description: 'Priority phone support', disabled: true },
    ],
  },
  {
    name: 'Free member',
    comingSoon: false,
    description: 'All the extras for your growing team.',
    priceMonthly: '$49',
    href: '#',
    highlights: [
      { description: 'Custom domains' },
      { description: 'Edge content delivery' },
      { description: 'Advanced analytics' },
      { description: 'Quarterly workshops' },
      { description: 'Single sign-on (SSO)', disabled: true },
      { description: 'Priority phone support', disabled: true },
    ],
  },
  {
    name: 'Premium',
    comingSoon: true,
    description: 'Added flexibility at Premium(coming soon).',
    priceMonthly: '$99',
    href: '#',
    highlights: [
      { description: 'Custom domains' },
      { description: 'Edge content delivery' },
      { description: 'Advanced analytics' },
      { description: 'Quarterly workshops' },
      { description: 'Single sign-on (SSO)' },
      { description: 'Priority phone support' },
    ],
  },
]
const sections = [
  {
    name: 'Features',
    features: [
      { name: 'Browse all content by topic', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
      { name: 'Search content library', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
      { name: 'View event listings', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
      { name: 'View directory listings', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
      { name: 'Save favourites', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
      { name: 'See star ratings', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
      { name: 'Access selected curated collections', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
      { name: 'Receive our newsletter (coming soon)', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
      { name: 'Access all curated collections', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
      { name: 'Attend premium webinars/events', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
      { name: 'Member only offers and early access', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },

    ],
  },
  // {
  //   name: 'Reporting',
  //   features: [
  //     { name: 'Advanced analytics', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
  //     { name: 'Basic reports', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
  //     { name: 'Professional reports', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
  //     { name: 'Custom report builder', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
  //   ],
  // },
  // {
  //   name: 'Support',
  //   features: [
  //     { name: '24/7 online support', tiers: { 'Non-member': true, 'Free member': true, 'Premium': true } },
  //     { name: 'Quarterly workshops', tiers: { 'Non-member': false, 'Free member': true, 'Premium': true } },
  //     { name: 'Priority phone support', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
  //     { name: '1:1 onboarding tour', tiers: { 'Non-member': false, 'Free member': false, 'Premium': true } },
  //   ],
  // },
]

export default function PricingGrid() {
  return (
    <div className="bg-transparent pt-6 pb-12">
      <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
        <table className="w-full text-left max-sm:hidden">
          <caption className="sr-only">Pricing plan comparison</caption>
          <colgroup>
            <col className="w-2/5" />
            <col className="w-1/5" />
            <col className="w-1/5" />
            <col className="w-1/5" />
          </colgroup>
          <thead>
            {/* <tr>
              <td className="p-0" />
              {tiers.map((tier) => (
                <th key={tier.name} scope="col" className="p-0">
                  <div className="text-base md:text-2xl font-bold text-white">
                    {`${tier.name}`}<span className="sr-only">plan</span>
                  </div>
                  {tier.comingSoon && <span className="text-sm font-light text-white">(coming soon)</span>}
                </th>
              ))}
            </tr> */}
            {/* <tr>
              <th className="p-0" />
              {tiers.map((tier) => (
                <td key={tier.name} className="px-0 pb-0 pt-3">
                  <a
                    href={tier.href}
                    aria-label={`Get started with the ${tier.name} plan`}
                    className="inline-block rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Get started
                  </a>
                </td>
              ))}
            </tr> */}
          </thead>
          {sections.map((section) => (
            <tbody key={section.name} className="group">
              <tr>
                <th className="px-0 pb-0 group-first-of-type:pt-5">
                  <div className="-mx-4 px-4 py-3 text-base md:text-2xl font-bold text-white">
                    {section.name}
                  </div>
                </th>
                {tiers.map((tier) => (
                  <th key={tier.name} scope="col" className="p-0">
                    <div className="text-base md:text-2xl font-bold text-white">
                      {`${tier.name}`}<span className="sr-only">plan</span>
                    </div>
                    {tier.comingSoon && <span className="text-sm font-light text-white">(coming soon)</span>}
                  </th>
                ))}
              </tr>
              {section.features.map((feature: any, idx: number) => (
                // <tr key={feature.name} className="border-b border-gray-100 last:border-none">
                <tr key={feature.name} className={`${idx % 2 === 0 ? 'bg-white/20' : 'bg-transparent'}`}>
                  <th scope="row" className="px-4 py-2 text-sm md:text-md font-bold text-white rounded-l-lg">
                    {feature.name}
                  </th>
                  {tiers.map((tier, t_idx: number) => (
                    <td key={tier.name} className={`px-4 py-2 max-sm:text-center ${t_idx === tiers.length - 1 && "rounded-r-lg"}`}>
                      {typeof feature.tiers[tier.name] === 'string' ? (
                        <>
                          <span className="sr-only">{tier.name} includes:</span>
                          <span className="text-sm/6 text-gray-950">{feature.tiers[tier.name]}</span>
                        </>
                      ) : (
                        <>
                          {feature.tiers[tier.name] === true ? (
                            <CheckIcon aria-hidden="true" className="inline-block size-4 md:size-5 text-white" />
                          ) : (
                            <MinusIcon aria-hidden="true" className="inline-block size-4 md:size-5 text-transparent" />
                          )}

                          <span className="sr-only">
                            {feature.tiers[tier.name] === true
                              ? `Included in ${tier.name}`
                              : `Not included in ${tier.name}`}
                          </span>
                        </>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ))}
        </table>
        <TabGroup className="sm:hidden">
          <TabList className="flex">
            {tiers.map((tier) => (
              <Tab
                key={tier.name}
                className="w-1/3 border-b border-white/30 py-4 text-base/8 font-bold text-white data-[selected]:border-white [&:not([data-focus])]:focus:outline-none"
              >
                {tier.name}
              </Tab>
            ))}
          </TabList>
          <TabPanels as={Fragment}>
            {tiers.map((tier) => (
              <TabPanel key={tier.name}>
                {sections.map((section) => (
                  <Fragment key={section.name}>
                    <div className="-mx-6 mt-10 rounded-lg bg-transparent px-6 py-3 text-sm/6 font-bold text-white group-first-of-type:mt-5">
                      {section.name}
                    </div>
                    <dl>
                      {section.features.map((feature: any) => (
                        <div
                          key={feature.name}
                          className="grid grid-cols-2 border-b border-white/30 py-4 last:border-none"
                        >
                          <dt className="text-sm/6 font-normal text-white">{feature.name}</dt>
                          <dd className="text-center">
                            {typeof feature.tiers[tier.name] === 'string' ? (
                              <span className="text-sm/6 text-gray-950">{feature.tiers[tier.name]}</span>
                            ) : (
                              <>
                                {feature.tiers[tier.name] === true ? (
                                  <CheckIcon aria-hidden="true" className="inline-block size-4 text-white" />
                                ) : (
                                  <MinusIcon aria-hidden="true" className="inline-block size-4 text-white" />
                                )}

                                <span className="sr-only">{feature.tiers[tier.name] === true ? 'Yes' : 'No'}</span>
                              </>
                            )}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </Fragment>
                ))}
              </TabPanel>
            ))}
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  )
}
